<!--
 * @Description: 
 * @Date: 2024-01-11 14:07:13
-->
<template>
  <div class="cover">
    <div
      v-move="{
        pos: props[item.posKey],
        change: (left:number, top:number) => onPosChange(item.posKey, left, top)
      }"
      v-input="{
        value: props[item.valueKey],
        change: (value:string) => onValueChange(item.valueKey, value)
      }"
      v-for="(item, index) in info"
      :data-edit="useEdit"
      :key="index"
      :class="{ [item.className]: true }"
      v-html="props[item.valueKey]"
    ></div>
    <div v-html="svg" class="svg"></div>
  </div>
</template>

<script setup lang="tsx">
import { withDefaults, defineProps, defineEmits } from 'vue';

import { vMove, vInput, useCover } from './index';
type Pos = { left: number; top: number; center?: boolean; initHeight?: number };
const props = withDefaults(
  defineProps<{
    useEdit?: boolean;
    projectName: string;
    time: string;
    mainPageEnterpriseName: string;
    titlePosition: Pos;
    settleTimePosition: Pos;
    aspNamePosition: Pos;
    orderNumber: string | number;
    orderNumberPostion: Pos;
  }>(),
  {}
);

const emits = defineEmits(['posChange', 'valueChange']);

const svg = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1630.914 1628.802">
  <g transform="translate(239.946 -84.633)">
    <path d="M733.024,832.065l559.705-498.557V266.141L670.285,820.582v11.483Z" transform="translate(-906.73 551.935)" fill="var(--theme-color-2)" stroke="#fff" stroke-miterlimit="10" stroke-width="7"/>
    <path d="M-8790,1647.392-9984.864,2753.26v193.123L-8790,1851.151Z" transform="translate(9981 -1269)" fill="var(--theme-color-1)" stroke="#707070" stroke-width="1"/>
    <path d="M1229.99,266.141,670.285,764.7V991.842L1292.729,437.4V266.141Z" transform="translate(-328.5 202.176)" fill="var(--theme-color-1)" stroke="#fff" stroke-miterlimit="10" stroke-width="7"/>
    <path d="M1229.99,266.141,670.285,764.7v67.367l622.444-554.441V266.141Z" transform="translate(94.739 292.896)" fill="var(--theme-color-2)" stroke="#fff" stroke-miterlimit="10" stroke-width="7"/>
    <path d="M1315.561,81,876.392,472.189V650.823L1368.584,212.4V81Z" transform="translate(-111.368 7.133)" fill="var(--theme-color-2)" stroke="#fff" stroke-miterlimit="10" stroke-width="7"/>
    <path d="M-9387.432,2483.7l-543.718,496.89" transform="translate(9981 -1269)" fill="none" stroke="var(--theme-color-1)" stroke-width="5"/>
  </g>
</svg>

`;

const { info, onPosChange, onValueChange } = useCover(emits);
</script>
<style lang="scss" scoped>
.cover {
  height: calc(var(--page-v3-height, 100%) - 2px);
  position: relative;
}
.svg {
  width: 100%;
  position: absolute;
  left: 0;
  top: 390px;
}

.project-name,
.time,
.order-number,
.enterprise-name {
  position: absolute;
  z-index: 2;
  user-select: none;
  font-weight: 600;
}
.project-name,
.time {
  font-size: 63px;
  color: #404040;
}

.project-name {
  min-width: 690px;
  max-width: 850px;
}
.time {
  max-width: 690px;
  font-size: 36px;
  min-width: 250px;
  // text-align: center;
}
.enterprise-name {
  font-size: 32px;
  color: #404040;
  text-align: center;
  width: 600px;
}
.order-number {
  font-size: 46px;
  font-weight: 500;
  color: #484848;
  font-family: PingFang SC;
  font-weight: 600;
}
</style>
